// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"1d991511e409865d","node_modules_canvg_lib_index_es_js":"5fa621cc18bb7279"}[chunkId] + ".js";
};